const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { letterSelected } = require('actions/glossary');
const GlossaryAlphabetLetter = require('./GlossaryAlphabetLetter');
require('./GlossaryAlphabetIndex.scss');


const ALL_FIRST_LETTERS = [
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o',
    'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
];


const GlossaryAlphabetIndex = ({ firstLettersWithResults, selectedLetter, selectLetter }) => (
    <nav className="container--index">
        <div className="no--scrollbar">
            {
                ALL_FIRST_LETTERS.map(letter => (
                    <GlossaryAlphabetLetter
                        active={letter === selectedLetter}
                        disabled={!firstLettersWithResults.includes(letter)}
                        key={letter}
                        onClick={() => selectLetter(letter)}
                    >
                        {letter.toUpperCase()}
                    </GlossaryAlphabetLetter>
                ))
            }
        </div>
    </nav>
);


GlossaryAlphabetIndex.propTypes = {
    firstLettersWithResults: PropTypes.array.isRequired,
    selectedLetter: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    selectLetter: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    firstLettersWithResults: state.glossary.firstLettersWithResults,
    selectedLetter: state.glossary.selectedLetter,
});

const mapDispatchToProps = dispatch => ({
    selectLetter: letter => dispatch(letterSelected({ letter })),
});


module.exports = connect(mapStateToProps, mapDispatchToProps)(GlossaryAlphabetIndex);
